export const routesTanitimYonetimSistemi = [
  {
    path: "/kys-yonetim-sistemi",
    name: "kys-yonetim-sistemi",
    component: () => import("@/views/kystanitim/yonetim-sistemi/index.vue"),
    meta: {
      public: false,
      title: "kystanitim.Yönetim Sistemi Tanıtım",
      yetki: { k: [1190102] },
    },
  },
]
